import React, { useState } from 'react'
import { useDelete, API, SearchModal, ViewHeader, Card, Pagination, Table, useGet, Filter, Help } from '@enkla-gui'
import { icons, filters } from '@config'
import { maintenancehelper } from '@/_helpers'
export default function RentAdjustmensOverview() {

	const { data, loading, setPage, sorting, setSorting, fetch: refresh } = useGet({ endpoint: `api/rentadjustment` })
	let { remove } = useDelete({
		endpoint: `api/rentadjustment/scheduled`,
		success: () => window.location.reload()
	})
	const { remove: removeAdjustment, loading: deleting } = useDelete({
		endpoint: 'api/rentadjustment/',
		confirm: 'Vill du radera denna schemalagda hyresjustering?',
		success: () => {
			if (data?.data?.length === 1 && data.current_page > 1) {
				setPage(data.current_page - 1)
			} else {
				refresh()
			}
		}
	})
	return (
		<>
			<ViewHeader title='Hyresjusteringar' subtitle='Översikt' icon={icons.percent}
				buttons={[{ icon: icons.create, title: 'Skapa', href: '#!/rentadjustment/create' },
				{ icon: icons.remove, title: 'Radera alla schemalagda', callback: remove, position: 'right' }
				]}
			/>
			<Card>
				<Table
					rows={data?.data}
					fetching={loading}
					useSorting={sort => setSorting({ ...sort })}
					sorting={sorting}
					empty={{
						text: 'Det finns inga hyresjusteringar',
						icon: icons.percentage
					}}
					functions={{
						remove: adjustment => adjustment.status === 'SCHEDULED' && (
							<button type='button' className='btn btn-sm btn-light table-icon-action' title='Radera hyresjustering' aria-label={`Radera hyresjustering för ${adjustment.entity?.name}`} disabled={deleting} onClick={() => removeAdjustment(adjustment.id)}>
								<i className={icons.remove} aria-hidden='true' />
							</button>
						),

						linked: linked => (
							<a class='text-decoration-none' onClick={e => e.stopPropagation()} href={`/#!/entity/${linked.id}/`}>
								{linked.name}
							</a>
						),
						status: status => status === 'SCHEDULED' ? <span class={`badge bg-warning w-100`}> Schemalagd </span> : <span class={`badge bg-success w-100`}> Utförd</span>
					}}
					keys={['status>function:status', 'entity>function:linked', 'rate>%', 'scheduled_at>date:short', 'executed_at>date:short', '_this>function:remove']}
					headers={[
						{
							value: 'Status',
							key: 'status',
							class: 'min'
						},
						{
							value: 'Objekt',
							key: 'entity'
						},
						{
							value: 'Förändring (%)',
							key: 'rate'
						},
						{
							value: 'Schemalagd',
							key: 'scheduled_at'
						},
						{
							value: 'Utförd',
							key: 'executed_at',
							sortable: true
						},
						{ value: '', class: 'min' },
					]}
				/>
				<Pagination data={data} fetch={setPage} />
			</Card>
		</>
	)
}
